package org.dronda.app.web.ui.nav

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import org.dronda.app.web.ui.Route
import kotlin.reflect.KClass

data class RouteAndComposable<T : Route>(
    val route: KClass<T>,
    val component: @Composable (T) -> Unit
)

class NavHostScope {
    @PublishedApi
    internal val routes = hashMapOf<KClass<Route>,RouteAndComposable<*>>()
    internal fun <T : Route> findRoute(kClass: KClass<T>): RouteAndComposable<Route>? {
        return routes[kClass as KClass<Route>]?.let {
            @Suppress("UNCHECKED_CAST")
            it as RouteAndComposable<Route>
        }
    }

    inline fun <reified T : Route> composable(noinline block: @Composable T.() -> Unit) {
        routes[T::class as KClass<Route>] = RouteAndComposable(T::class, block)
    }
}

@Composable
fun NavHost(
    modifier: Modifier = Modifier,
    currentRouteState: MutableState<Route>,
    build: NavHostScope.() -> Unit
) {
    val scope = NavHostScope()
    with(scope) { build() }

    Box(modifier) {
        val currentRoute by currentRouteState
        val route: RouteAndComposable<Route> = scope.findRoute(currentRoute::class) ?: error("Route not registered")
        with(route) {
            component(currentRoute)
        }
    }
}
